export const ACTOR = {
  USER: 'USER'
};